import styled from 'styled-components';
import tw from 'twin.macro';

export default styled.div(({ $top, $zIndex, $bottom }) => [
  tw`sticky z-1`,
  $top ? `top: ${$top / 16}rem;` : tw`top-0`,
  $zIndex && `z-index: ${$zIndex};`,
  $bottom && tw`top-auto bottom-0`
]);
